export default "__VITE_ASSET__B8RpFhdv__"